import { supabase, isSupabaseConfigured } from '@/lib/supabase';

// Extrae la ruta relativa del archivo dentro del bucket a partir de una URL
// pública de Supabase Storage (formato .../storage/v1/object/public/<bucket>/<path>).
// Devuelve null si la URL no corresponde a este bucket (p. ej. una URL externa
// pegada a mano), en cuyo caso no hay nada que borrar de Storage propio.
export function extractStoragePath(bucket: string, url: string): string | null {
  const marker = `/object/public/${bucket}/`;
  const idx = url.indexOf(marker);
  if (idx === -1) return null;
  return url.slice(idx + marker.length).split('?')[0];
}

// Borra un archivo del bucket de Storage a partir de su URL pública. Si la URL
// no es de Storage propio (URL externa), no hace nada y devuelve sin error.
export async function removeStorageFile(
  bucket: string,
  url: string,
): Promise<{ error: string | null }> {
  const path = extractStoragePath(bucket, url);
  if (!path) return { error: null };

  if (!isSupabaseConfigured || !supabase) {
    return { error: 'Supabase no está configurado. No se pudo borrar el archivo.' };
  }

  try {
    const { error } = await supabase.storage.from(bucket).remove([path]);
    if (error) return { error: error.message };
    return { error: null };
  } catch (err) {
    console.warn(`[storage] remove failed (${bucket}):`, err);
    return { error: 'Error de conexión al borrar el archivo.' };
  }
}